"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // ARCHITECT-CONTAINERS [ TABLE ] ##############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var Table = function Table(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? [] : _ref$header,
      _ref$headersAsc = _ref.headersAsc,
      headersAsc = _ref$headersAsc === void 0 ? {} : _ref$headersAsc,
      sortBy = _ref.sortBy;

  var normaliseKeys = function normaliseKeys(obj) {
    var cloned = obj;

    for (var key in obj) {
      var val = cloned[key];
      delete cloned[key];
      cloned[key.toLowerCase()] = val;
    }

    return cloned;
  }; // 2.1. FUNCTIONS ............................................................
  // 2.1.1. RENDER HEADER


  var renderHeader = function renderHeader(headerData) {
    return _react["default"].createElement(_index.TableHeader, null, headerData.map(function (label, index) {
      var k = sortBy && label.replace(/\s/g, '').toLowerCase();
      return _react["default"].createElement(_index.TableHeaderCell, {
        key: index,
        onClick: function onClick() {
          return sortBy && sortBy(k);
        }
      }, label, " ", sortBy && _react["default"].createElement(_index.AngleUpDown, {
        size: "small",
        order: headersAsc[k]
      }));
    }));
  }; // 2.1.1. END
  // 2.1.1. RENDER ROWS


  var renderRows = function renderRows(data) {
    return data.map(function (row, index) {
      return _react["default"].createElement(_index.TableRow, {
        key: index
      }, renderCells(row));
    });
  }; // 2.1.1. END
  // 2.1.2. RENDER CELLS


  var renderCells = function renderCells(data) {
    return Object.keys(data).map(function (key, index) {
      return _react["default"].createElement(_index.TableCell, {
        key: index
      }, data[key]);
    });
  }; // 2.1.2. END
  // 2.1. END ..................................................................
  // 2.2. RENDER COMPONENT .....................................................


  return _react["default"].createElement(_index.TableContainer, null, renderHeader(header), renderRows(data.map(function (e) {
    return normaliseKeys(e);
  }))); // 2.2. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


Table.propTypes = {
  data: _propTypes["default"].array,
  header: _propTypes["default"].array,
  sortBy: _propTypes["default"].func
}; // 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = Table; // END OF FILE #################################################################

exports["default"] = _default;